import { Link } from "react-router-dom";
import { Linkedin, Instagram, Youtube, Facebook } from "lucide-react";

const LOGO = "/adaptience-logo.png";

const XIcon = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/adaptience/", Icon: Linkedin },
  { label: "Instagram", href: "https://www.instagram.com/adaptience/", Icon: Instagram },
  { label: "YouTube", href: "https://www.youtube.com/@Adaptience", Icon: Youtube },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61593527274288", Icon: Facebook },
  { label: "X", href: "https://x.com/Adaptience", Icon: XIcon },
];

const SocialRow = () => (
  <div className="-my-2 flex items-center gap-0.5" data-testid="footer-socials">
    {SOCIALS.map(({ label, href, Icon }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Adaptience on ${label}`}
        data-testid={`social-${label.toLowerCase()}`}
        className="inline-flex items-center justify-center rounded-full p-2.5 text-white/55 transition-colors hover:text-[#4FA3D9] focus-visible:text-[#4FA3D9] focus-visible:outline-none"
      >
        <Icon size={18} />
      </a>
    ))}
  </div>
);

export const SiteFooter = () => (
  <footer className="border-t border-white/[0.08] py-12" data-testid="landing-footer">
    <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
      <div className="flex items-center">
        <img src={LOGO} alt="Adaptience" className="h-5 w-auto" />
        <sup className="ml-0.5 text-[8px] text-white/40">™</sup>
      </div>
      <Link to="/contact" data-testid="footer-contact" className="text-sm text-white/55 transition-colors hover:text-white">
        Contact
      </Link>
      <div className="flex items-center gap-6 text-sm text-white/60">
        <Link to="/privacy" className="transition-colors hover:text-white/80" data-testid="footer-privacy">Privacy</Link>
        <Link to="/terms" className="transition-colors hover:text-white/80" data-testid="footer-terms">Terms</Link>
      </div>
    </div>
    <div className="mt-8 flex items-center justify-between gap-4">
      <p className="text-xs text-white/45">© 2026 Adaptience™</p>
      <SocialRow />
    </div>
  </footer>
);

export default SiteFooter;
